/* eslint-disable */
export default {
  _input_background: 'input_background',
  _intro_background: 'intro_background',
  _help_popup: 'help_popup',
  _color_button: 'color_button',
  _create_button: 'create_button',
  _randomize_button: 'randomize_button',
  _word_limit_button: 'word_limit_button',
  _blue_item_background: 'blue_item_background',
  _font_button: 'font_button',
  _layout_button: 'layout_button',
  _menu_button: 'menu_button',
  _start_button: 'start_button',
  _m5: 'm5',
  _l1: 'l1',
  _check_mark: 'check_mark',
  _l4: 'l4',
  _m1: 'm1',
  _x_mark: 'x_mark',
  _slider: 'slider',
  _up_arrow: 'up_arrow',
  _m4: 'm4',
  _w1: 'w1',
  _m6: 'm6',
  _l2: 'l2',
  _l3: 'l3',
  _m2: 'm2',
  _m3: 'm3',
  _l5: 'l5',
  _l6: 'l6',
  _l7: 'l7',
  _white_item_background: 'white_item_background',
  _l8: 'l8',
  _l9: 'l9',
  _l10: 'l10',
}